<div class="lead-multiple-step-by-step">
  <div class="title-container">
    <div class="title" fiTranslation="MESSAGE_BULK_OVERLAY_HEADER"></div>
  </div>
  <div class="progress">

    <div class="title-icon">
      <img [src]="iconUrl" alt="file-forward">
    </div>
    &nbsp;
    <mat-progress-bar mode="determinate" class="pre-download-progress-bar" [value]="progressValue"></mat-progress-bar>
    &nbsp;
    <div class="title-icon">
      <img [src]="actionIconUrl" alt="file-forward">
    </div>
  </div>

  <div #stepStreamListener class="step-container">
    {{ liveStreamOfLeadsProgress }}
  </div>
  <div class="close-btn" (click)="cancel()">
    <span fiTranslation="MESSAGE_BULK_OVERLAY_CANCEL"></span>
  </div>

</div>

